import { ConversationSummary } from '@types';
import { createGetEndpoint } from '@sonar-software/sonar-http';

export type GetConversationRequest = {
	id: number;
};

export const getConversation = createGetEndpoint<GetConversationRequest, ConversationSummary>(
	({ id }) => `/api/v3/agent/conversations/${id}`
);
